import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  makeGetAllChildrenByTaskIdSelector,
  makeGetSortedTaskIdsSelector,
} from "~/store/selectors/selector.taskDependencies.jsx";
import TaskDependencies from "./TaskDependencies.jsx";

const ChildTasksContainer = ({ taskId, ...rest }) => {
  const { t } = useTranslation();
  const getAllChildrenIdsByTaskId = useMemo(makeGetAllChildrenByTaskIdSelector, []);
  const getSortedTaskIds = useMemo(makeGetSortedTaskIdsSelector, []);

  const parents = useSelector((state) => getAllChildrenIdsByTaskId(state, taskId));
  const tasks = useSelector((state) => getSortedTaskIds(state, parents));

  return tasks.length > 0 ? (
    <TaskDependencies
      {...rest}
      tasks={tasks}
      headerText={t("Successors")}
      taskId={taskId}
    />
  ) : null;
};

ChildTasksContainer.propTypes = {
  taskId: PropTypes.number,
};

export default ChildTasksContainer;
